const config = {
  insert: 'top',
  container: 'top-center',
  animationIn: ['animate__animated', 'animate__fadeIn'],
  animationOut: ['animate__animated', 'animate__fadeOut'],
  dismiss: {
    duration: 5000,
    onScreen: true,
    pauseOnHover: true,
    showIcon: true
  },
  width: 350
}

export default config
